import { IProductDetails } from '@models/IProductDetails';
import axios from 'axios';
import qs from 'qs';

interface Params {
  readonly getRelationsByMaterialCodeEndpoint: string;
  readonly language: string;
  readonly materialCode: string;
}

const getProductRelations = async ({
  getRelationsByMaterialCodeEndpoint,
  language,
  materialCode,
}: Params): Promise<IProductDetails> => {
  const query = qs.stringify({
    language,
    materialCode,
  });

  const { data } = await axios.get<IProductDetails>(
    `${getRelationsByMaterialCodeEndpoint}?${query}`
  );

  return data;
};

export default getProductRelations;
